import { RequestKind, boolean, string } from '@sb/library/base';
import { BatchReminderPreferencesUpdateItem, DisplayItemCollection, EmailAttachmentInputItem, ReminderPreferencesUpdateItem, SendEmailInputItem, SendEmailResultItem, SenderDiagnosticDisplayItem, SenderDiagnosticInputItem, SentMessageDisplayItem, SentMessageSearchOptions, UnblockEmailInputItem, UnblockSMSInputItem, VerifyEmailInputItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace MessagingRoutes {
    export const Get = ApiRoute.Define({
        URL: (messageID: string) => `messages/${messageID}`,
        Kind: RequestKind.Get,
        ResultType: SentMessageDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: 'messages',
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<SentMessageDisplayItem>,
        PagingAllowed: true
    });

    export const Search = ApiRoute.Define({
        URL: 'search/messages',
        Kind: RequestKind.Post,
        BodyType: SentMessageSearchOptions,
        ResultType: DisplayItemCollection<SentMessageDisplayItem>,
        PagingAllowed: true
    });

    export const SendEmail = ApiRoute.Define({
        URL: 'messages',
        Kind: RequestKind.Post,
        BodyType: SendEmailInputItem,
        ResultType: SendEmailResultItem
    });

    export const Delete = ApiRoute.Define({
        URL: (messageID: string) => `messages/${messageID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const DeleteMessageGroups = ApiRoute.Define({
        URL: (messageGroupID: string) => `messagegroups/${messageGroupID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const AddAttachments = ApiRoute.Define({
        URL: 'messageattachments',
        Kind: RequestKind.Post,
        BodyType: EmailAttachmentInputItem,
        ResultType: string
    });

    export namespace Unblock {
        export const Email = ApiRoute.Define({
            URL: 'unblockemail',
            Kind: RequestKind.Post,
            BodyType: UnblockEmailInputItem,
            ResultType: boolean
        });

        export const SMS = ApiRoute.Define({
            URL: 'unblocksms',
            Kind: RequestKind.Post,
            BodyType: UnblockSMSInputItem,
            ResultType: boolean
        });
    }

    export const VerifyEmail = ApiRoute.Define({
        URL: 'verifyemail',
        Kind: RequestKind.Post,
        BodyType: VerifyEmailInputItem,
        ResultType: boolean
    });

    export const SenderDiagnostic = ApiRoute.Define({
        URL: 'senderdiagnostic',
        Kind: RequestKind.Post,
        BodyType: SenderDiagnosticInputItem,
        ResultType: SenderDiagnosticDisplayItem
    });

    export namespace Reminders {
        export const Batch = ApiRoute.Define({
            URL: 'reminders',
            Kind: RequestKind.Patch,
            BodyType: BatchReminderPreferencesUpdateItem,
            ResultType: boolean
        });

        export const Update = ApiRoute.Define({
            URL: (profileID: string) => `reminders/${profileID}`,
            Kind: RequestKind.Put,
            BodyType: ReminderPreferencesUpdateItem,
            ResultType: boolean
        });
    }
}
